import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'
import '@vant/touch-emulator'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'

import * as echarts from "echarts";

import store from './store'//引入Vuex

import FloatTools from './components/FloatTools'
import PageQr from './components/PageQr'
import SetDetails from './components/SetDetails'
//import AddressEdit from './components/AddressEdit'

import Site from './assets/js/site.js'

import './directive/waves/waves.js'


import { 
  Button,
  Icon,
  Cell, CellGroup,
  Calendar,
  Card,
  Tag,
  Checkbox, CheckboxGroup,
  Radio, RadioGroup,
  Image,
  Lazyload,
  Swipe, SwipeItem,
  NavBar,
  Sticky,
  Grid, GridItem,
  Stepper,
  SubmitBar,
  Dialog,
  Popup,
  Form,
  DropdownMenu, DropdownItem,
  Field,
  ActionSheet,
  PullRefresh,
  List,
  Toast,
  Collapse, CollapseItem,
  Tab, Tabs,
  Switch,
  Rate,
  Uploader,
  Slider,
  //ImagePreview,
  //Area,
  Picker,
} from 'vant'

Vue.use(Button)
  .use(Cell).use(CellGroup)
  .use(Calendar)
  .use(Icon)
  .use(Checkbox).use(CheckboxGroup)
  .use(Radio).use(RadioGroup)
  .use(Card)
  .use(Tag)
  .use(Image)
  .use(Lazyload)
  .use(Swipe).use(SwipeItem)
  .use(NavBar)
  .use(Sticky)
  .use(Grid).use(GridItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(DropdownMenu).use(DropdownItem)
  .use(Field)
  .use(ActionSheet)
  .use(PullRefresh)
  .use(List)
  .use(Toast)
  .use(Collapse).use(CollapseItem)
  .use(Tab).use(Tabs)
  .use(Switch)
  .use(Uploader)
  .use(Rate)
  .use(Slider)
  //.use(ImagePreview)
  .use(Picker);
  //.use(Area);

Vue.use(Site);

Vue.use(VueAxios, axios);

Vue.use(FloatTools)
  .use(PageQr)
  .use(SetDetails)
  //.use(Goodsframe)
  //.use(modifypriceframe);

//======= 注册自定义组件
Vue.component('FloatTools', FloatTools);
Vue.component('PageQr', PageQr);
Vue.component('SetDetails', SetDetails);
//Vue.component('AddressEdit', AddressEdit);

Vue.prototype.qs = qs;

Vue.prototype.$echarts = echarts;

//======= 路由守卫
router.beforeEach((to, from, next) => {

  //电动车环境中，用某既定页面替代首页
  // if( to.path === '/' && store.state.browser.giantevapp ) {
  //   //router.replace({ path: '/land/' + store.state.giantEvIndexId});
  //   location.replace('/#/land/' + store.state.giantEvIndexId);
  //   setTimeout(function(){
  //     location.reload();
  //   }, 500);
  //   return false;
  // }

  //路由发生变化修改页面title
  if (to.meta.title) {
    if(to.path === '/') {
      document.title = '积木小站';
    } else {
      document.title = to.meta.title + ' - 积木小站';
    }
    //console.log(store.state.browser)
    if(store.state.browser.wxminiprogram){
      wx.miniProgram.postMessage({ data: {shareTitle: document.title} });
      //console.log(66666666);
    }
    if(store.state.browser.bdminiprogram){
      swan.webView.postMessage({ data: {shareTitle: document.title} });
      //console.log(66666666);
    }
    //console.log(111111);
  }

  // alert("from:" + from.fullPath);
  // alert("to:" + to.fullPath);


  // console.log("from:", from);
  // console.log("to:", to);

  //给路由全局添加一个时间戳参数，用于判断是前进还是后退
  //console.log(to.query._t, typeof to.query._t, typeof to.query._t !== 'undefined', to.name == 'SearchSet');

  //------------ 开始
  if (
    typeof to.query._t !== 'undefined' || 
    to.name == 'SearchSet' || 
    to.name == 'Index' || 
    to.name == 'IndexBrand' || 
    to.name == 'IndexTheme'
  ) {
    //console.log("直接走");
    next();
  } else {
    if( from && to.fullPath.replace(/_t=\d+$/g, "").replace(/[\?\&]$/g, "") == from.fullPath.replace(/_t=\d+$/g, "").replace(/[\?\&]$/g, "") ){
      //console.log("tmpSame：true");
      //next();

      if( typeof to.query._t == 'undefined' ){
        //Vue.$router.go(-1)
        history.back();
      } else {
        next();
      }

    } else {
      //console.log("tmpSame：false");
      to.query._t = new Date().getTime().toString();
      //next({...to, replace: true});
      next(to);
    }
  }
  //------------ 结束








  // if (typeof to.query._t !== 'undefined' || to.name == 'SearchSet') {
  //   console.log("直接走");
  //   next();
  // } else {
  //   if( from && from.name == to.name ){
  //     if( to.fullPath.replace(/_t=\d+$/g, "").replace(/[\?\&]$/g, "") == from.fullPath.replace(/_t=\d+$/g, "").replace(/[\?\&]$/g, "") ){
  //       console.log("tmpSame：true");
  //       next();
  //     } else {
  //       console.log("tmpSame：false");
  //       to.query._t = new Date().getTime().toString();
  //       next({...to, replace: true});
  //     }
  //   } else {
  //     console.log("非相同路由");
  //     to.query._t = new Date().getTime().toString();
  //     next({...to, replace: true});
  //   }


  // }



  // function JSONLength(obj) {
  //   var size = 0, key;
  //   for (key in obj) {
  //     if (obj.hasOwnProperty(key)) size++;
  //   }
  //   return size;
  // };
  // if (typeof to.query._t !== 'undefined' || to.name == 'SearchSet') {
  //   next();
  // } else {
  //   if( from && from.name == to.name ){
  //     console.log(JSONLength(to.query), JSONLength(from.query));////////////
  //     if( JSONLength(to.query) + 1 == JSONLength(from.query) && to.path == from.path ){
  //       let tmpSame = true;
  //       for (to_i in to.query) {
  //         for (from_i in from.query) {
  //           if( to_i != '_t' && to_i == from_i && to.query['to_i'] != to.query['from_i'] ){
  //             tmpSame = false;
  //           }
  //         }
  //       }
  //       if( tmpSame ){console.log("tmpSame：true");
  //         next();
  //       } else {console.log("tmpSame：false");
  //         to.query._t = new Date().getTime().toString();
  //         next(to);
  //       }
  //     } else {
  //       to.query._t = new Date().getTime().toString();
  //       next(to);
  //     }

  //   } else {
  //     to.query._t = new Date().getTime().toString();
  //     next(to);
  //   }


  // }




  //分享信息
  // let metaList = document.getElementsByTagName('meta');
  // for (var i = 0; i < metaList.length; i++) {
  //   if (metaList[i].getAttribute("name") == "shareImg") {
  //     metaList[i].content = store.state.siteUrl + "/static/img/share_logo.png";
  //   }
  //   if (metaList[i].getAttribute("name") == "shareTitle") {
  //     metaList[i].content = document.title;
  //   }
  //   if (metaList[i].getAttribute("name") == "shareDesc") {
  //     metaList[i].content = '捷安特在线商城是捷安特公司精心为用户打造的自行车购物及服务平台';//document.title;
  //   }
  //   if (metaList[i].getAttribute("name") == "shareLink") {
  //     let tmpMeta = metaList[i];
  //     setTimeout(function(){
  //       tmpMeta.content = location.href;
  //     }, 100);
  //   }
  // }

  /*
  //获取到已登录的用户信息
  let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));
  
  if( loginuser_data && loginuser_data.sessionkey ){
    store.commit('updateLoginUser', loginuser_data);
  } else {
    //判断当前页是否需要登录
    if( to.meta.requireLogin ){
      //console.log(location.href);
      router.replace({ path: '/login', query: { redirect: location.href }});
      //router.replace({ path: '/login', query: { redirect: to.fullPath }});
      //router.push({ path: '/login', query: { redirect: to.fullPath }});
    }
  }
  */
  next();
});

Vue.config.productionTip = false;

const _Vue = new Vue({
  router,
  store,
  components: { App },
  render: h => h(App),
}).$mount("#app");

export default _Vue;


// WEBPACK FOOTER //
// ./src/main.js